import styled from "styled-components/macro";
import { Heading4 } from "styles/elements/Headings";
import { Paragraph, ParagraphCss } from "styles/elements/Texts";
import type { ElearningTheme } from "themes/elearning.theme";

interface Props {
  theme: ElearningTheme;
}

export const StyleLogo = styled.img`
  height: 30px;
`;

export const StyleText = styled(Paragraph)`
  margin-bottom: 18px;
`;

export const StyleFooter = styled.div`
  padding: 20px;
  width: 100%;
  background-color: ${(props: Props) => props.theme.palette.neutral.white};
  display: flex;
  flex-direction: row;
  a {
    ${ParagraphCss};
    margin-bottom: 18px;
    text-decoration: none;
    color: ${(props: Props) => props.theme.palette.neutral.black};
  };
`;

export const StyleTitle = styled(Heading4)`
  margin-bottom: 18px;
`;

export const List = styled.div`
  margin-right: 40px;
  max-width: 240px;
  min-width: 160px;
  display: flex;
  flex-direction: column;
`;

export const ImageContainer = styled.div`
  height: 46px;
  display: flex;
  flex-direction: row;
  margin-top: 16px;
  margin-right: 20vw;
  align-items: center;
  justify-content: center;
`;
